export const verbs = [
  // 1. Forma bazë
  {
    id: 'infinitiv',
    category: 'verbs',
    level: 'A1',
    title: 'Infinitiv (Forma bazë e foljes)',
    detailedContent: `
      <section>
        <p><b>Infinitivi</b> është forma bazë, e pazgjedhuar e foljes. Kjo është forma sesi folja prezantohet në fjalor. Në gjuhën gjermane, pothuajse të gjitha foljet në infinitiv mbarojnë me prapashtesën <b>-en</b> (p.sh. <i>lernen</i> - mësoj, <i>spielen</i> - luaj) ose rrallëherë vetëm me <b>-n</b> (p.sh. <i>sammeln</i> - mbledh, <i>feiern</i> - festoj).</p>

        <h3>1. Kur përdoret Infinitivi?</h3>
        <ul>
          <li><b>Pas foljeve modale:</b> Kur në fjali kemi një folje modale (können, müssen, etj.), folja e dytë shkon gjithmonë në fund të fjalisë në formën infinitiv pa "zu".<br/>P.sh. <i>Ich <b>muss</b> heute viel <b>lernen</b>.</i></li>
          <li><b>Në kohën e ardhme (Futur I):</b> Formohet me foljen ndihmëse <i>werden</i> + infinitiv.<br/>P.sh. <i>Morgen <b>werde</b> ich nach Berlin <b>fahren</b>.</i></li>
          <li><b>Me "zu" (Infinitiv mit zu):</b> Shumë folje e kërkojnë infinitivin me "zu" pas tyre.<br/>P.sh. <i>Ich habe vor, Deutsch <b>zu lernen</b>.</i></li>
          <li><b>Pas disa foljeve specifike pa "zu":</b> gehen, kommen, bleiben, lassen, sehen, hören.<br/>P.sh. <i>Wir <b>gehen</b> heute Abend <b>tanzen</b>.</i></li>
        </ul>

        <h3>2. Infinitivi si emër (Nominalisierung)</h3>
        <p>Çdo infinitiv i foljes mund të kthehet në emër asnjëanës (das). Për t'a bërë këtë, infinitivi shkruhet me shkronjë të madhe. Kthimi i foljes në emër përshkruan procesin e vetë veprimit.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> infinitiv me shkronjë të madhe = gjithmonë treguesi "das".
          <br/>P.sh: <i>lesen</i> (lexoj) -> <i><b>das</b> Lesen</i> (të lexuarit).
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Shembuj të Infinitivit',
        headers: ['Gjermanisht', 'Përkthimi në shqip', 'Prapashtesa'],
        rows: [
          ['mach-en', 'bëj', '-en'],
          ['komm-en', 'vij', '-en'],
          ['segel-n', 'lundroj', '-n'],
          ['lächel-n', 'buzëqesh', '-n']
        ]
      }
    ],
    examples: [
      { ger: 'Ich möchte ein Auto kaufen.', alb: 'Dua të blej një makinë. (Pas foljes modale "möchten" folja "kaufen" rri në infinitiv prapa)' },
      { ger: 'Das Lesen ist mein Hobby.', alb: 'Të lexuarit (leximi) është hobi im. (Infinitivi si emër das Lesen)' },
      { ger: 'Wir sehen die Kinder spielen.', alb: 'Ne shohim fëmijët duke luajtur. (Pas foljes "sehen" infinitivi "spielen")' }
    ],
    exercises: [
      { question: 'Si kthehet folja "schwimmen" në emër?', options: ['die Schwimmen', 'das Schwimmen', 'der Schwimmen'], correct: 1, explanation: 'Të gjithë infinitivët e transformuar në emër (Nominalisierte Infinitive) marrin nyjën "das".' },
      { question: 'Pas cilave nga foljet e mëposhtme, folja vihet në infinitiv pa "zu"?', options: ['haben', 'müssen', 'vergessen'], correct: 1, explanation: 'Foljet modale si "müssen", "können" etj., kërkojnë që folja e dytë rri në infinitiv pa "zu".' }
    ]
  },
  {
    id: 'verbstamm',
    category: 'verbs',
    level: 'A1',
    title: 'Verbstamm (Rrënja e foljes)',
    detailedContent: `
      <section>
        <p><b>Rrënja e foljes (Verbstamm)</b> është thelbi i fjalës, nga e cila formohen të gjitha trajtat e tjera (koha e tashme, e shkuar, pjesoret etj.).</p>

        <h3>1. Si e gjejmë rrënjën e foljes?</h3>
        <p>Për të gjetur rrënjën e një foljeje, thjesht merrni formën e <b>infinitivit</b> dhe hiqni prapashtesën <b>-en</b> ose <b>-n</b>.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> Infinitiv minus -en/-n = Rrënja e foljes (Verbstamm)
        </div>

        <h3>2. Cili është funksioni i rrënjës së foljes?</h3>
        <p>Mbi këtë rrënjë, i shtohen pastaj prapashtesat përkatëse sipas vetës (ich, du, er, etj.) ose sipas kohës (Präsens, Präteritum).</p>
        <p>Për shembull: nëse rrënja është <b>mach-</b>, për vetën 'ich' shtojmë <b>-e</b> => <i>ich mach<b>e</b></i>.</p>

        <h3>3. E veçanta tek rrënjët që mbarojnë me -t, -d, -m, ose -n.</h3>
        <p>Nëse rrënja e foljes përfundon në <b>-t</b> (p.sh. arbeiten => arbeit-), <b>-d</b> (finden => find-), ose disa raste me -m/-n, nevojitet të shtohet një bashkëtingëllore ndihmëse <b>-e-</b> para prapashtesës së vetës së 2-të (du) dhe 3-të njëjës (er/sie/es), dhe vetës së 2-të shumës (ihr) për të lehtësuar shqiptimin.</p>
        <p>P.sh: arbeit-en -> <i>du arbeit-<b>e</b>-st</i> (jo arbeitst), <i>er arbeit-<b>e</b>-t</i>.</p>
      </section>
    `,
    tables: [
      {
        label: 'Shembuj të Krijimit të Rrënjës',
        headers: ['Infinitiv', 'Prapashtesa', 'Rrënja (Verbstamm)'],
        rows: [
          ['wohn-en (banoj)', '-en', 'wohn-'],
          ['komm-en (vij)', '-en', 'komm-'],
          ['arbeit-en (punoj)', '-en', 'arbeit-'],
          ['handel-n (veproj)', '-n', 'handel-']
        ]
      }
    ],
    examples: [
      { ger: 'Lernen -> Ich lerne.', alb: 'Rrënja "lern-" merr mbaresën "-e".' },
      { ger: 'Finden -> Du findest.', alb: 'Rrënja mbaron me -d ("find-"), shtojmë -e- për lehtësi: find-e-st.' }
    ],
    exercises: [
      { question: 'Cila është rrënja e foljes "trinken"?', options: ['tri', 'trink', 'trinken'], correct: 1, explanation: 'Duke hequr prapashtesën -en nga "trinken", ne fitojmë rrënjën "trink".' },
      { question: 'Kur rrënja mbaron me "-t" (p.sh. warten), çfarë theksojmë tek veta e 2-të (du)?', options: ['Shtojmë direkt -st (wartst)', 'Shtojmë -e- ndërmjetëse (wartest)', 'Lëmë vetëm rrënjën (wart)'], correct: 1, explanation: 'Foljet që e kanë rrënjën me -t, marrin -e- shtesë: du wart-e-st.' }
    ]
  },
  {
    id: 'partizip-ii',
    category: 'verbs',
    level: 'A2',
    title: 'Partizip II (Pjesorja e shkuar)',
    detailedContent: `
      <section>
        <p><b>Partizip II</b> (Pjesorja e së shkuarës) është forma foljore e përdorur, ndër të tjera, thelbësisht për të krijuar kohën Perfekt, Plusquamperfekt dhe gjithashtu formën pësore (Passiv).</p>

        <h3>1. Si formohet Partizip II tek Foljet e Rregullta (Schwache Verben)?</h3>
        <p>Rregulli bazë për foljet e rregullta (të dobëta) është i thjeshtë:</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> ge- + Verbstamm + -t
          <br/>P.sh. lernen -> ge-lern-t = <b>gelernt</b>
        </div>
        <p>Nëse rrënja mbaron me -d ose -t, shtojmë <b>-et</b>. <i>arbeit-en -> ge-arbeit-<b>et</b></i>.</p>

        <h3>2. Si formohet Partizip II tek Foljet e Parregullta (Starke Verben)?</h3>
        <p>Foljet e forta ndërtojnë pjesoren me <b>-en</b> në vend të -t, dhe në të shumtën e rasteve pësojnë ndryshime të zanores së rrënjës.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> ge- + Verbstamm i ndryshuar + -en
        </div>
        <ul>
          <li><b>Nuk ndryshohet zanorja:</b> sehen -> ge-seh-en = <b>gesehen</b></li>
          <li><b>Ndryshim zanor:</b> singen -> ge-sung-en = <b>gesungen</b></li>
        </ul>

        <h3>3. Përjashtimet Kryesore (Kujdes!)</h3>
        <ul>
          <li><b>Foljet që mbarojnë me "-ieren":</b> (studieren, telefonieren, reparieren). Këto folje <b>NUK</b> marrin "ge-". Ato mbarojnë thjeshtë me -t.<br/>P.sh. studieren -> <b>studiert</b>.</li>
          <li><b>Foljet e pandashme (untrennbare Verben):</b> me parashtesat be-, ver-, ent-, zer-, er-, etj. Këto folje gjithashtu <b>NUK</b> e marrin "ge-".<br/>P.sh. besuchen -> <b>besucht</b> (jo gebesucht), verstehen -> <b>verstanden</b>.</li>
          <li><b>Foljet e ndritshme (trennbare Verben):</b> "ge-" futet midis parashtesës dhe rrënjës.<br/>P.sh. aufstehen -> auf-<b>ge</b>-standen, einkaufen -> ein-<b>ge</b>-kauft.</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Llojet e Partizip II',
        headers: ['Forma', 'Infinitiv', 'Partizip II', 'Rregulli'],
        rows: [
          ['E rregullt', 'kaufen', 'gekauft', 'ge- + rrënja + -t'],
          ['E fortë (pa ndryshim rr.)', 'lesen', 'gelesen', 'ge- + rrënja + -en'],
          ['E fortë (me ndryshim rr.)', 'finden', 'gefunden', 'ge- + rr. e re + -en'],
          ['Me "-ieren"', 'passieren', 'passiert', 'rrënja + -t (pa ge-)'],
          ['E pandashme', 'bezahlen', 'bezahlt', 'pa ge-'],
          ['E ndritshme', 'anrufen', 'angerufen', 'parashtesë + ge + rr + en']
        ]
      }
    ],
    examples: [
      { ger: 'Ich habe gestern Fußball gespielt.', alb: 'Dje kam luajtur futboll. (spielen → gespielt)' },
      { ger: 'Wir sind um 7 Uhr aufgestanden.', alb: 'Ne u zgjuam në orën 7. (aufstehen → auf-ge-standen, sepse "auf" ndahet)' },
      { ger: 'Er hat auf der Universität studiert.', alb: 'Ai ka studiuar në universitet. (studieren → studiert, pa "ge-")' }
    ],
    exercises: [
      { question: 'Cila është forma e Partizip II për foljen "besuchen"?', options: ['gebesucht', 'besuchen', 'besucht'], correct: 2, explanation: 'Foljeta me parashtesën "be-" janë të pandashme dhe prandaj NUK e marrin "ge-". Zgjidhja është "besucht".' },
      { question: 'Si formohet Partizip II për "einkaufen"?', options: ['einkauft', 'eingekauft', 'geeinkauft'], correct: 1, explanation: 'Folja "ein-" është parashtesë e ndashme. Prandaj "ge-" vendoset në mes: ein-ge-kauft.' }
    ]
  },

  // 2. Zeiten
  {
    id: 'praesens',
    category: 'verbs',
    level: 'A1',
    title: 'Präsens (Koha e tashme)',
    detailedContent: `
      <section>
        <p><b>Präsens</b> është koha e tashme në gjuhën gjermane. Është koha më e përdorur dhe ka aplikim të gjerë edhe në situata ku në gjuhë të tjera mund të përdoret e ardhmja apo mënyra të tjera.</p>

        <h3>1. Kur përdoret Präsens?</h3>
        <ul>
          <li><b>Për diçka që po ndodh aktualisht në këtë moment:</b> <i>Ich lese ein Buch.</i> (Po lexoj një libër.)</li>
          <li><b>Për fakte të përgjithshme ose vërtetësi shkencore:</b> <i>Die Erde dreht sich um die Sonne.</i> (Toka rrotullohet rreth Diellit.)</li>
          <li><b>Për ngjarje të planifikuara në të ardhmen:</b> Shpesh me tregues kohor. <i>Wir fahren morgen nach Berlin.</i> (Neser udhëtojmë/do të udhëtojmë për Berlin - nuk është rreptësisht i detyrueshëm Futur I.)</li>
        </ul>

        <h3>2. Zgjedhimi (Konjugation) i foljeve të rregullta</h3>
        <p>Zgjedhimi i rregullt i foljeve bëhet duke marrë Rrënjën e foljes (Verbstamm) dhe duke shtuar mbaresat personale.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Mbaresat janë:</strong> -e, -st, -t, -en, -t, -en. 
        </div>

        <h3>3. Përjashtimet (Ausnahmen)</h3>
        <ul>
          <li><b>Ndryshimi i zanores në rrënjë:</b> Disa folje të forta (Starke Verben) marrin një ndryshim me zanoren kryesore të tyre (e -> i, e -> ie, a -> ä) kryesisht <b>vetëm</b> në vetat <i>du</i> dhe <i>er/sie/es</i>. <br/>P.sh: <i>sprechen</i> -> er spr<b>i</b>cht. <i>fahren</i> -> du f<b>ä</b>hrst. <i>lesen</i> -> er l<b>ie</b>st.</li>
          <li><b>Foljet që përfundojnë me -t ose -d, -m, -n në rrënjë:</b> Siç e pamë, këto marrin një "e" të ndërmjetme tek veta e 2të njëjës (du), veta 3të njëjës (er) dhe veta 2të shumës (ihr) për tu thënë më lehtë (p.sh. arbeiten -> du arbeit<b>e</b>st).</li>
          <li><b>Foljet me mbaresën -s, -ß, -x, -z në rrënjë:</b> Në vetën e 2të njëjës "du" hiqet shkronja "s" nga mbaresa e rregullt "-st". Pra ngelet vetëm "-t".<br/>P.sh: heißen -> du heiß-t.</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Zgjedhimi i rregullt (machen)',
        headers: ['Veta', 'Mbaresa', 'Zgjedhimi'],
        rows: [
          ['ich (unë)', '-e', 'mache'],
          ['du (ti)', '-st', 'machst'],
          ['er/sie/es (ai/ajo)', '-t', 'macht'],
          ['wir (ne)', '-en', 'machen'],
          ['ihr (ju)', '-t', 'macht'],
          ['sie/Sie (ata/ato/Ju formal)', '-en', 'machen']
        ]
      },
      {
        label: 'Ndryshimet e zanores ("e" → "i") (sprechen)',
        headers: ['Veta', 'Ndryshimi', 'Zgjedhimi'],
        rows: [
          ['ich', 'e ashtu siç është', 'spreche'],
          ['du', 'e → i', 'sprichst'],
          ['er/sie/es', 'e → i', 'spricht'],
          ['wir', 'rikthehet "e"', 'sprechen'],
          ['ihr', 'rikthehet "e"', 'sprecht'],
          ['sie/Sie', 'rikthehet "e"', 'sprechen']
        ]
      }
    ],
    examples: [
      { ger: 'Ich spiele am Wochenende Fußball.', alb: 'Fundjavave luaj futboll. (Veprim periodik - me mbaresën -e për "ich").' },
      { ger: 'Du fährst zu schnell.', alb: 'Po nget makinen tepër shpejt. (fahren ka ndryshim "a → ä" në vetën e dytë).' },
      { ger: 'Wir fliegen nächsten Monat nach Spanien.', alb: 'Muajin tjetër fluturojmë për Spanjë. (Präsens i përdorur për të shprehur të ardhmen).' }
    ],
    exercises: [
      { question: 'Cila është zgjedhimi i saktë i "arbeiten" për vetën e dytë shumës (ihr)?', options: ['ihr arbeitet', 'ihr arbeitt', 'ihr arbeiten'], correct: 0, explanation: 'Rrënja e "arbeiten" është "arbeit-", meqë përfundon në "-t", duhet shtuar "-e-" përpara mbaresës "-t" -> ihr arbeit-e-t.' },
      { question: 'Cila është fjalimi i saktë për "er" (leximi)?', options: ['er lest', 'er liest', 'er leest'], correct: 1, explanation: 'Folja "lesen" është folje e fortë që pëson ndryshimin zanor "e -> ie" për vetat e 2të dhe të 3të njëjës: du liest, er liest.' }
    ]
  },
  {
    id: 'perfekt',
    category: 'verbs',
    level: 'A2',
    title: 'Perfekt (E kaluara e përbërë)',
    detailedContent: `
      <section>
        <p><b>Perfekti</b> është koha e shkuar kryesore në komunikimin oral të gjuhës gjermane. Thuajse të gjitha bisedat, chati me shokët ose njoftimet jozyrtare do e përdorin gjithnjë këtë formë, krahasuar me Präteritum që gjendet më shumë në libra.</p>

        <h3>1. Si formohet Perfekti? (Bildung)</h3>
        <p>Jemi duke lidhur bashkë një <b>folje ndihmëse (haben ose sein) të zgjedhuar + Partizip II të foljes në fund</b>.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> Subjekt + haben/sein (e zgjedhuar) + [tekst tjetër i fjalisë] + Partizip II (në fund absolut të fjalisë!)
        </div>

        <h3>2. "haben" vs "sein"</h3>
        <p>Zgjedhja e foljes ndihmëse nuk jepet "me hamendje" por ka rregulla strikte.</p>
        
        <h4>Përdorim me <i>sein</i>:</h4>
        <p>Të gjitha foljet që konfirmojnë:</p>
        <ol>
          <li><b>Ndryshim lokacioni:</b> Lëvizja nga vendi A te vendi B. Si: <i>gehen, fahren, fliegen, laufen, schwimmen, springen, reisen</i>.<br/><i>Ich <b>bin</b> in die Schule <b>gegangen</b>. (Unë shkova në shkollë).</i></li>
          <li><b>Ndryshim gjendjeje:</b> Proces fizik i brendshëm ndryshimi. Si: <i>einschlafen</i> (fle), <i>aufwachen</i> (zgjohem), <i>sterben</i> (vdes), <i>wachsen</i> (rritem).<br/><i>Der Baum <b>ist</b> schnell <b>gewachsen</b>.</i></li>
          <li><b>Përjashtime specifike:</b> Foljet specifikisht të listëzuara si <i>sein</i> (jam), <i>bleiben</i> (qëndroj), <i>werden</i> (bëhem), <i>passieren</i> (ndodh), <i>gelingen</i>.<br/><i>Wir <b>sind</b> zu Hause <b>geblieben</b> (Ne qëndruam në shtëpi - pavarësisht se nuk ka ndryshim vendi, bleiben përdor "sein").</i></li>
        </ol>

        <h4>Përdorim me <i>haben</i>:</h4>
        <p>Të gjitha rastet e tjera! (mbi 90% e foljeve).</p>
        <ul>
          <li>Foljet që marrin Akuzativ kërkojnë DOEMOS "haben": essen (çfarë?), sehen, machen, kopen, kochen...</li>
          <li>Foljet reflekshive: sich waschen (<i>Ich habe mich waschen</i>).</li>
          <li>Foljet e gjendjes pa ndryshim vendi: stehen, sitzen, liegen, schlafen.</li>
        </ul>
        
        <p class="mt-4 text-xs italic text-gray-500">Shënim: Në Austria/Zvicër (ose pjesë jugore të Gjermanisë), "stehen", "sitzen" dhe "liegen" përdorin shpesh "sein" (Ich bin gesessen), por vlen "haben" si standarti High-German (Ich habe gesessen).</p>
      </section>
    `,
    tables: [
      {
        label: 'Shembuj Strukturor të Perfekt-it',
        headers: ['Pozicioni 1', 'Pozicioni 2 (Ndihmësja)', 'Mes', 'Pozicioni i fundit (Part.II)'],
        rows: [
          ['Ich', 'habe', 'gestern eine Pizza', 'gegessen.'],
          ['Die Kinder', 'sind', 'nach der Schule nach Hause', 'gelaufen.'],
          ['Wir', 'haben', 'unsere Hausaufgaben', 'gemacht.'],
          ['Er', 'ist', 'im Seminar in der Pause', 'eingeschlafen.']
        ]
      }
    ],
    examples: [
      { ger: 'Gestern habe ich mit Anna telefoniert.', alb: 'Dje kam folur në telefon me Anën. ("telefonieren" nuk është lëvizje, ndaj merr "haben").' },
      { ger: 'Was ist gestern passiert?', alb: 'Çfarë ndodhi dje? ("passieren" bën pjesë tek përjashtimet qe marrin "sein").' },
      { ger: 'Wir sind im Urlaub nach Italien geflogen.', alb: 'Ne fluturuam drejt Italisë për pushime. ("fliegen" është ndryshim vendi A->B ndaj do "sein").' }
    ],
    exercises: [
      { question: 'Zgjidh fjalinë e saktë:', options: ['Ich bin gestern gegessen.', 'Ich habe gestern ein Buch lesen.', 'Ich habe eine Pizza gegessen.'], correct: 2, explanation: 'Folja "essen" nuk ka detalim i ndryshimi i gjendjes apo vendit, ndaj merr "haben". Zgjidhja është "habe [...] gegessen". (lesen e ka partizipin gelesen jo lesen).' },
      { question: 'Pse folja "aufwachen" (zgjohem) e zgjedhon perfektin me "sein"?', options: ['Sepse ne hapim sytë', 'Sepse ka të bëj me Zotin', 'Sepse tregon ndryshim të gjendjes (nga fjetur -> zgjuar)'], correct: 2, explanation: 'Të gjitha veprimet që tregojnë tranzicion të trupit nga një gjendje në tjetrën (einschlafen, aufwachen, sterben...) marrin "sein".' }
    ]
  },
  {
    id: 'praeteritum',
    category: 'verbs',
    level: 'B1',
    title: 'Präteritum (E kaluara e thjeshtë / narrative)',
    detailedContent: `
      <section>
        <p><b>Präteritum</b> (i quajtur edhe "Imperfekt") është koha e shkuar letrare ose narrative. Kjo periudhë zakonisht gjendet vetëm më shkrime, si tek leximi i librave, përrallave, letrave formale gazetareske apo literaturës historike.</p>

        <h3>1. Kur e përdorim Präteritum-in sot?</h3>
        <ul>
          <li><b>Në jetën e përditshme (Folur):</b> Thuajse NUK e përdorim. Zëvendësohet me Perfekt.</li>
          <li><b>PËRJASHTIME KRYESORE!</b> Foljet "haben", "sein" dhe <b>Foljet Modale</b> përdoren MË SHPESH në Präteritum sesa në Perfekt edhe kur FLASTE GJUHË E FOLUR. <br/>Kështu njerëzit do thonin <i>"Ich war krank"</i> në vend të <i>"Ich bin krank gewesen"</i>. Për modale: <i>"Ich wollte schlafen"</i> dhe jo <i>"Ich habe schlafen wollen"</i>.</li>
        </ol>

        <h3>2. Formimi për Foljet e Rregullta (Schwache Verben)</h3>
        <p>Në mes të rrënjës së foljes dhe mbaresës, ne vendosim vetiu treguesin kohor të Präteritum, që është germa <b>"-t-"</b> ose sillaba <b>"-te-"</b>.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Rregulli:</strong> Verbstamm + <b>-te</b> + mbaresa e vetës. 
          <br/><strong>Kujdes:</strong> Veta e parë "ich" dhe veta e tretë "er/sie/es" janë totalisht TË BARABARTA dhe s'marrin asnjë mbaresë shtesë përveç treguesit "-te".
        </div>
        <p><i>machen -> mach-te -> "ich machte", "du mach-test", "er machte"</i></p>

        <h3>3. Formimi për Foljet e Parregullta (Starke Verben)</h3>
        <p>Foljet e forta nuk i shtohet "-te" në mes, POR Ato e shndërrojnë thelbësisht të gjithë rrokje/zanoren rrënjësore bazike. Ky lloj duhet thjesht të <b>mësohet përmendësh</b>.</p>
        <p><i>gehen -> ging -> "ich ging", "du gingst", "er ging", "wir gingen"</i>.<br/>Mbaresa për ich dhe er mungon edhe në këtë rast.</p>

        <h3>4. Präteritumi i SEIN, HABEN, dhe WERDEN</h3>
        <p>Këto janë absolutisht thelbësore dhe përdoren vazhdimisht:</p>
        <ul>
          <li><b>sein</b> (të jesh) -> rrënja Präteritum: <b>war</b> -> <i>ich war, du warst, er war...</i></li>
          <li><b>haben</b> (të kesh) -> rrënja Präteritum: <b>hatte</b> -> <i>ich hatte, du hattest, er hatte...</i></li>
          <li><b>werden</b> (të bëhesh) -> rrënja Präteritum: <b>wurde</b> -> <i>ich wurde, du wurdest, er wurde...</i></li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Zgjedhimi në Präteritum',
        headers: ['Veta (Pronomen)', 'machen (e rregullt: -te)', 'kommen (e fortë: kam)', 'sein (war)'],
        rows: [
          ['ich', 'machte', 'kam', 'war'],
          ['du', 'machtest', 'kamst', 'warst'],
          ['er, sie, es', 'machte', 'kam', 'war'],
          ['wir', 'machten', 'kamen', 'waren'],
          ['ihr', 'machtet', 'kamt', 'wart'],
          ['sie, Sie', 'machten', 'kamen', 'waren']
        ]
      }
    ],
    examples: [
      { ger: 'Als ich Kind war, spielte ich oft draußen.', alb: 'Kur isha fëmijë luaja shpesh jashtë. (Tregon formë tregimit me "war" dhe "spielte")' },
      { ger: 'Es war einmal ein König, der hatte drei Töchter.', alb: 'Na ishte njëherë një Mbret që kishte tre vajza. (Stil klasik i nisjes së përrallave)' },
      { ger: 'Letztes Jahr hatten wir ein großes Problem.', alb: 'Vitin e kaluar ne kishim një problem të madh. (Përdorim i "hatten" në vend të perfekte për thjeshtësi bisede).' }
    ],
    exercises: [
      { question: 'Si është Präteritumi i vetës së 3të njëjës (er) për foljen e rregullt "arbeiten"?', options: ['er arbeitete', 'er arbeitett', 'er arbeite'], correct: 0, explanation: 'Folja e rregullt, merr treguesin -te, po ama ajo vetë mbaron me -t. Kështu bëhet arbeit + e + te = arbeitete.' },
      { question: 'Pse veta e 1-rë dhe e 3-të janë të ngjashme në Präteritum?', options: ['Ashtu është sistemi gjerman', 'E dyta merr dyfishte prapashtese', 'Ato nuk i marrin mbaresat personale fare pas tregutuesve te shkuares'], correct: 2, explanation: 'Të dyja vetat (ich & er/sie/es) në Präteritum thjesht nuk marrin parashtesë personalizuese të re. Ato i bashkohen fundoreve "-te" ose fjalës së ndryshuar pa shtesë (ich ging, er ging).' }
    ]
  },
  {
    id: 'plusquamperfekt',
    category: 'verbs',
    level: 'B1',
    title: 'Plusquamperfekt (Të Kryerat / Më se e Kryera)',
    detailedContent: `
      <section>
        <p><b>Plusquamperfekt</b>, apo koha "Më e Se e Kryera", i referohet një momenti të së shkuarës, PARA një veprimi tjetër po të së shkuarës. Jemi duke përshkruar një veprim që ishte kryer e vulosur përfundimisht para ndërmarrjes së një aksioni të dytë.</p>

        <h3>1. Kur dhe Si përdoret?</h3>
        <p>Zakonisht Plusquamperfekt gjendet vetëm në lajme komplekse dhe romane. Në gjithë jetën ai vjen 90% të rasteve i shoqëruar me lidhëzën kohore <b>"nachdem" (pasi)</b>.</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Ndarja kronologjike:</strong> 
          <br/>Veprimi i PARË në kohë = Plusquamperfekt. 
          <br/>Veprimi i DYTË në kohë = Präteritum (ose ndonjëherë Perfekt).
        </div>
        <p>P.sh: Pasi Hans GËRTHITI me të madhe (1 - Plusquamperfekt), mamaja erdhi e friksuar (2 - Präteritum).</p>
        <p><i>Nachdem Hans laut geschrien hatte, kam die Mutter erschrocken zur Tür.</i></p>

        <h3>2. Si Formohet?</h3>
        <p>Formimi është pothuajse ekzakt si formimi i kohës <b>Perfekt</b> i përditshme.</p>
        <p>I vetmi ndryshim nga Perfekt, është se atë <b>haben / sein</b> që tek perfekt ishin zgjedhuar në të tashmen, tani i transformojmë në vetë Präteritum: <b>hatte / war</b>.</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> Subjekt + <b>hatte / war (zgjedhur)</b> + ... + Partizip II
        </div>
        <ul>
          <li><b>Në vend të:</b> Ich habe gegessen. (Unë i kam ngrënë).</li>
          <li><b>Do të kemi:</b> Ich hatte gegessen. (Unë i KISHA ngrënë)</li>
        </ul>
      </section>
    `,
    tables: [
      {
        label: 'Plusquamperfekt Strukturë Krahasimore',
        headers: ['Koha: Tani (Präsens)', 'Koha: E shkuara nr 2 (Perfekt)', 'Koha e shkuara qe thellë, nr 1 (Plusquamperfekt)'],
        rows: [
          ['Er macht das Hausaufgaben.', 'Er hat das Hausaufgaben gemacht.', 'Er <b>hatte</b> das Hausaufgaben <b>gemacht</b>.'],
          ['Wir gehen ins Kino.', 'Wir sind ins Kino gegangen.', 'Wir <b>waren</b> ins Kino <b>gegangen</b>.']
        ]
      }
    ],
    examples: [
      { ger: 'Ich konnte die Arbeit nicht verstehen, weil ich das Buch vorher nicht gelesen hatte.', alb: 'Nuk munda t\'a kuptoja tezën, sepse MË PËRPARA nuk e kisha lexuar librin. (Dy evente në të shkuarën, mosleximi ka ndidhur i pari => Plusquamperfekt, Moskuptimi i dyti => Präteritum)' },
      { ger: 'Nachdem wir eingekauft hatten, fuhren wir zurück nach Hause.', alb: 'Pasi KISHIM BËRË PAZAR (1), ne u kthyem per ne shtëpi me makinë (2).' }
    ],
    exercises: []
  },
  {
    id: 'futur-i',
    category: 'verbs',
    level: 'B1',
    title: 'Futur I (E ardhmja - Parashikime, Premtime)',
    detailedContent: `
      <section>
        <p>Koha kryesore për të shprehur <b>të ardhmen</b> quhet <b>Futur I</b>. Në të folurën e përditshme dëgjojme shpesh përdorimin e kohës së tashme (Präsens) me ndajfolje kohe si "nesër" ose "së shpejti" për asertu ngjarjet e sigurta afërme, por megjithatë "Futur I" gjendet tek premtimet, qëllimet bindëse dhe planet formale.</p>

        <h3>1. Kur përdoret?</h3>
        <ul>
          <li><b>Sypoze ose Parashikim (Vermutung in der Zukunft / Gegenwart):</b> "Sie wird wohl morgen ankommen" / "Das Wetter wird morgen schön sein". (Në letërsi dëgjosh një si mundsi gjasash a parashikimesh).</li>
          <li><b>Premtime thelbësore (Versprechen):</b> "Ich werde dich für immer lieben!" (Do tw pwrgjithmonw! Nuk thua 'ich liebe dich morgen' si tregim fakti normal).</li>
          <li><b>Kërkesë autoritare (Aufforderung mit starkem Ton):</b> "Du wirst jetzt sofort deine Hausaufgaben machen!" (Ju TANI do bwsh/plotwsosh detyrat tuja! - Ndalesa nwntingull kundershtues).</li>
        </ul>

        <h3>2. Si formohet?</h3>
        <p>E ardhmja ndesh dy fjalë thelbësore mbledhur së bëshku:</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> Subjekt + ndihmësja <b>werden (zgjedhuar si prezent)</b> + ... + <b>Folja thelbësore në Infinitiv absolut në Fünd</b>.
        </div>
      </section>
    `,
    tables: [
      {
        label: 'Zgjedhimi thelbësor i "werden"',
        headers: ['Veta (Pronomen)', 'werden (zgjedhimi prezent)', 'Pozicioni fundor'],
        rows: [
          ['ich', 'werde', '... helfen.'],
          ['du', 'wirst', '... helfen.'],
          ['er/sie/es', 'wird', '... helfen.'],
          ['wir', 'werden', '... helfen.'],
          ['ihr', 'werdet', '... helfen.'],
          ['sie/Sie', 'werden', '... helfen.']
        ]
      }
    ],
    examples: [
      { ger: 'Es wird am Samstag regnen.', alb: 'Do të bjerë shi të shtunën. (Një parashikim moti - Përdor Futur 1 stilit lajme)' },
      { ger: 'Keine Sorge, ich werde dir helfen!', alb: 'Mos u shqetëso, unë do të të ndihmoj!' }
    ],
    exercises: []
  },
  {
    id: 'futur-ii',
    category: 'verbs',
    level: 'B2',
    title: 'Futur II (Do të jetë kryer)',
    detailedContent: `
      <section>
        <p>Futur II, një kohë relativisht e avancuar (Niveli B2/C1). Tregon për një veprim të ardhshëm që në momentin fiks kur i referohet tjetër në të ardhmen, AI VEPRIM DO KETЁ PЁRFUNDUAR e VETËKRYER plotësisht.</p>

        <h3>1. Kur dhe si ndërtohet logjika?</h3>
        <p>Dua the them "Deri nesër në orën tetë, e TËRA KJO PROVË do KETË PËRFUNDUAR".</p>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula e thellë:</strong> Subjekt + <b>werden (zgjedh.)</b> +... + <b>Partizip II</b> + <b>haben/sein nga pas pa zgjedhur (ne inf)</b>.
        </div>
        <p>Duket kompleks, sepse ne vendin e Fundit kemi 2 folje bashkë, sepse është derivat i të perfektes në të ardhme!</p>
        <p>P.sh: <i>Bis morgen <b>werde</b> ich das Buch <b>gelesen haben</b>.</i></p>

        <h3>2. Ose për Supozimet e thella në të tashmen?</h3>
        <p>Futur II përdoret masivisht në formatin "Ai sigurisht ka vajtur në bar ngaq është vonë". Suponojmë dikë në t'shkuar. <i>"Er wird wohl schon angekommen sein".</i> (Supozim: Besoj ai ka mberritur me gjasave thella sigurie).</p>
      </section>
    `,
    tables: [],
    examples: [
      { ger: 'Morgen um 15 Uhr werde ich mein Auto repariert haben.', alb: 'Nesër rreth orës 15, unë DO TA KEM RIPARUAR makinën time (gjithcka e kryer)' }
    ],
    exercises: []
  },

  // 3. Llojet e Foljeve Kategorizimet
  {
    id: 'regelmaessige-verben',
    category: 'verbs',
    level: 'A1',
    title: 'Regelmäßige & Schwache Verben (Foljet e Rregullta të dobëta)',
    detailedContent: `
      <section>
        <p>Në gjermanisht, ata e quajn "Schwache Verben" (E dobët) - në fakt këto janë të Rregulltat. Fjala e dobët mban sensin qe ata e perkasin nje rregulli unik baze me e dorezu qe ata ndertojne trajta te bindshme, nuk e ndryshojne fare zanoren e tytr thelbit.</p>

        <h3>1. Pse njihet si e rregullt?</h3>
        <ul>
          <li>Në të dyja rastet të kaluarat <b>(Präteritum the Partizip)</b> ajo lë rrënjën e vet plotësisht TË PAPERKEKSHME. Asnjë germa zanafe nuk nderohet.</li>
          <li>Këto zgjedhimet marrin shume thjesht shtesim "-te-" per prateritum the "-t/" ge"-t... per perfekt.</p></li>
        </ul>
        <p>Përbajn masën me te larte te foljeve gjuhtatore e kryesat ne epoken kohes se sotme si gjithe foljet e rrjetave sociale "twittern", "googeln", etc.</p>

      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'unregelmaessige-verben',
    category: 'verbs',
    level: 'A1',
    title: 'Unregelmäßige Verben',
    detailedContent: '<p>Këto e referojn term gjithpfshirës cdo gjë ku forma e fjalës nuk mund të parashikohet prej modelitt total dhe per tju nënshtruar rregulltës klasike.</p>',
    exercises: []
  },
  {
    id: 'starke-verben',
    category: 'verbs',
    level: 'B1',
    title: 'Starke Verben (Foljet e Forta)',
    detailedContent: `
      <section>
        <p>U themele quhen "Të Fortr" sepse sipas letërsisë së vjetër thellë Gjerma - ato zotërojnë vetëvetit të thatë force "energji nga brenda" për t'u shëndërruar dhe treguar trajnat e së kaluarës pikerisht TË BRËNDSHME duke ndrruar Zanore-Thelb ! Ndaj gjuha nuk e "shtyn" ato të gjitha si "-te" apo ndime formim kofize nga tjetër.</p>

        <h3>1. Karakteristikat e 3:</h3>
        <ol>
          <li><b>Në Präteritum:</b> Zanoret ndryshojn plotesisht pa mbaruar me -te. (singen -> sang, sehen -> sah, fliegen -> flog).</li>
          <li><b>Në Partizip II:</b> Fjala e funnde mbaron me <b>-EN</b> dhe kurrsesi me -t!. (gesungen, gesehen, geflogen).</li>
          <li><b>Në Präsens kohorë sot:</b> Disa prej tyra bejn ndri-zanore per (du, er) duke dhene 'e -> i' ase 'a -> ä'. (ich sehe -> du siehst).</li>
        </ol>

        <p>Numri i tyre eshte diku reth 170-200. Thjesht memorizohen si 3 format e tyre klasike : <i>singen, sang, gesungen</i> ; <i>bleiben, blieb, geblieben</i>; <i>schreiben, schrieb, geschrieben</i>.</p>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  { id: 'schwache-verben', category: 'verbs', level: 'A1', title: 'Schwache Verben', detailedContent: '<p>Të gjitha foljet e rregullta. (Shih Regelmäßige Verben).</p>', exercises: [] },
  { id: 'gemischte-verben', category: 'verbs', level: 'B1', title: 'Gemischte Verben (Foljet e Përziera)', detailedContent: `
      <section>
        <p>Një miks thelbësor: Foljet "E Përziera" sillën si e forta Dhe si e dobët ne njeten koh.</p>
        <ul>
          <li>Ato tregojn forcë qe ndryshojne zanoren baz (si Starke-Verben): bringen → br<b>a</b>chte, wissen → w<b>u</b>sste.</li>
          <li>Por ato i marrin mbaresat pikerisht sit ë dobëta klasike ! me "-te" ne Praterit dhe "t" dhe fund për perfekte !. (brachte, gebracht)</li>
        </ul>
        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Shembuj klasikë :</strong> bringen, denken, kennen, nennen, rennen, senden, wissen.
        </div>
        <p>denken (mendoj) → d<b>a</b>ch<b>te</b> (Prät) → hat ged<b>a</b>ch<b>t</b> (Perf)</p>
        <p>wissen (di) → w<b>u</b>ss<b>te</b> (Prät) → hat gew<b>u</b>ss<b>t</b> (Perf)</p>
      </section>
    `, exercises: [] },

  // 4. Folje të veçanta
  {
    id: 'modalverben',
    category: 'verbs',
    level: 'A1',
    title: 'Modalverben (Foljet Modale)',
    detailedContent: `
      <section>
        <p><b>Foljet Modale</b> janë folje speciale që modifikojnë "menyrën - mos-o-sakt" ose domethenien e dëshirave thelbësore të fjalisë. Në vend te thuash "Un lexoj libra", ti e thellon mesazhin tek "Un DUA / DUHET/ MUND te lexoj libra".</p>

        <h3>1. Cilat janë Të 6-Tat?</h3>
        <ul>
          <li><b>können</b>: (Mundem) - Jep aftesi / talent fizik ose mundesive e një rasti. <i>(Ich kann Klavier spielen).</i></li>
          <li><b>müssen</b>: (Duhet/Detyrimi i that) - Nëse s'bëhet gjëndja do perfundon keq e detyrueshme. <i>(Ich muss arbeiten, um Geld zu verdienen.)</i></li>
          <li><b>dürfen</b>: (Të lejohet) - Autoritet i jepshëm e lejes prej prinderve ose shteje. <i>(Hier darf man nicht rauchen!)</i></li>
          <li><b>wollen</b>: (Dua themeltë - Vullnet i brendshëm) - Tregon vendosmëri absolute e plane konkrete. <i>(Ich will nach Deutschland ziehen.)</i></li>
          <li><b>sollen</b>: (Duhet rekomanduar / Moralisht / Sipas Tjerëve) - Detyrim moral e dhenie këshillës ose obligum treguar qe "e tha mjeku". <i>(Der Arzt sagt, ich soll Medikamente nehmen.)</i></li>
          <li><b>mögen</b>: (Të pëlqen person/gjë e mos veprim) - Kthejm shpesh gjate ne "ich möchte" (un dëshiroj lehtësishme the formal) njelloj me wanting po më me politike edukimi formale.</li>
        </ul>

        <h3>2. Rregulli i Strukturës në Fjali</h3>
        <p>Foljet Modale marrin pozitën kryesore 2 në fjali (plotësisth tek thelb Zgjedhumi), kurse FOLJA ZHVILLUESE BAZË e shtyrë kthehet n'gjëndet PËR PËRGJITHSISHT si Infinitv Absolut n'fund formale! Tërë kjo formon një "Morsë (Klammer)" tipike GJERMANE fjalisht.</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Formula:</strong> Subjekt + [Folje Modale E Zgjedhuar nr 2] + ... + <b>Folja thelbësore nw INFINITIV në FUND pa Zu</b>.
          <br>P.sh. <i>Ich <b>muss</b> heute bis 20 Uhr im Büro <b>bleiben</b>.</i>
        </div>

        <h3>3. E Veçanta Zgjedhuar e tyra (Vetësore)</h3>
        <p>Për ALL vetat (Ich, er/es/sie), për foljet kryesore modale e nderojm thelbin e tyra zanore nw njehesin me t'tër form, the po aq Munges mbaresore '-e' as '-t', rrafshe si nj'gjajshme prateritshe!</p>
        <p>müssen --> <i>ich m<b>u</b>ss! ; du m<b>u</b>sst ; er/sie m<b>u</b>ss !!!</i> (nuk e do -t tvetia!)</p>
      </section>
    `,
    tables: [
      {
        label: 'Zgjedhimet thelbore Modale në Präsens',
        headers: ['Veta', 'können', 'müssen', 'dürfen', 'wollen', 'sollen', 'mögen'],
        rows: [
          ['ich', 'kann', 'muss', 'darf', 'will', 'soll', 'mag'],
          ['du', 'kannst', 'musst', 'darfst', 'willst', 'sollst', 'magst'],
          ['er/sie/es', 'kann', 'muss', 'darf', 'will', 'soll', 'mag'],
          ['wir', 'können', 'müssen', 'dürfen', 'wollen', 'sollen', 'mögen'],
          ['ihr', 'könnt', 'müsst', 'dürft', 'wollt', 'sollt', 'mögt'],
          ['sie/Sie', 'können', 'müssen', 'dürfen', 'wollen', 'sollen', 'mögen']
        ]
      }
    ],
    examples: [
      { ger: 'Hier darf man nicht rauchen.', alb: 'Këtu nuk lejohet (nuk ka të drejtë) të pish duhan.' },
      { ger: 'Kannst du mir helfen?', alb: 'Mund(A mundet të tregosh mundesim-dëshmie) të më ndihmosh?' }
    ],
    exercises: [
      { question: 'Zejeni veshjen gjëje: "Er ____ gut singen" (Ai posedon aftësi me kendu bukur)', options: ['dürft', 'willst', 'kann'], correct: 2, explanation: 'Sepse ësh aftësi përdorim "kann", nersa zanafilla zgjedhuar esht "er kann".' }
    ]
  },
  { id: 'hilfsverben', category: 'verbs', level: 'A1', title: 'Hilfsverben (Foljet ndihmëse)', detailedContent: '<p>sein, haben, werden. Përdoren për të ndërtuar kohët e përbëra.</p>', exercises: [] },
  { id: 'reflexive-verben', category: 'verbs', level: 'A2', title: 'Reflexive Verben', detailedContent: '<p>Foljet që kërkojnë një përemër vetëvetor (sich). P.sh: sich waschen.</p>', exercises: [] },
  { id: 'trennbare-verben', category: 'verbs', level: 'A2', title: 'Trennbare Verben', detailedContent: '<p>Foljet me parashtesë që ndahet. P.sh: aufstehen, anrufen.</p>', exercises: [] },
  { id: 'untrennbare-verben', category: 'verbs', level: 'B1', title: 'Untrennbare Verben', detailedContent: '<p>Foljet me parashtesa që nuk ndahen kurrë (be-, ver-, ent-, er-, zer-...).</p>', exercises: [] },

  // 5. Valenz
  { id: 'verb-akk', category: 'verbs', level: 'A2', title: 'Verben mit Akkusativ', detailedContent: '<p>Shumica e foljeve në gjermanisht kërkojnë Akuzativ. P.sh: essen, trinken, haben.</p>', exercises: [] },
  { id: 'verb-dat', category: 'verbs', level: 'A2', title: 'Verben mit Dativ', detailedContent: '<p>Foljet si: helfen, danken, gratulieren, kërkojnë Dativ.</p>', exercises: [] },
  { id: 'verb-dat-akk', category: 'verbs', level: 'B1', title: 'Verben mit Dativ und Akkusativ', detailedContent: '<p>Foljet si: geben, schenken, bringen. "Kujt (Dativ) çfarë (Akkusativ)".</p>', exercises: [] },
  { id: 'verb-praep', category: 'verbs', level: 'B2', title: 'Verben mit Präposition', detailedContent: '<p>Folje që lidhen me parafjalë fikse. P.sh: warten auf, denken an.</p>', exercises: [] },

  // 6. Forma të tjera
  { id: 'imperativ', category: 'verbs', level: 'A2', title: 'Imperativ (Urdhërorja)', detailedContent: '<p>Përdoret për urdhra ose kërkesa. P.sh: Geh! Kommt! Gehen Sie!</p>', exercises: [] },
  { id: 'konjunktiv-i', category: 'verbs', level: 'C1', title: 'Konjunktiv I', detailedContent: '<p>Përdoret për të rrëfyer fjalët e dikujt tjetër (Indirekte Rede).</p>', exercises: [] },
  { id: 'konjunktiv-ii', category: 'verbs', level: 'B2', title: 'Konjunktiv II', detailedContent: '<p>Përdoret për dëshira jo reale, supozime ose mirësjellje (würde, hätte, wäre).</p>', exercises: [] },
  { id: 'indirekte-rede', category: 'verbs', level: 'C1', title: 'Indirekte Rede (Rrëfimi i tërthortë)', detailedContent: '<p>Raportimi i asaj që ka thënë dikush pa përdorur thonjëza.</p>', exercises: [] }
];
